import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusResponse: false,
    updateStatusResponse: false,
    updateStatusTimeOutResponse: false,
    listCredentials: [],
    listTerminales: [],
    listTerminals: [],
    terminalResponse: null,
  },
  mutations: {

    setListCredentials (state, data) {
      state.listCredentials = data
    },
    setListTerminales (state, data) {
      state.listTerminales = data
    },
    setListTerminals (state, data) {
      state.listTerminals = data
    },
    setTerminalResponse (state, data) {
      state.terminalResponse = data
    },
    setResponseCredentials (state, data) {
      state.statusResponse = data
    },
    setUpdateResponseCredentials (state, data) {
      state.updateStatusResponse = data
    },
    setUpdateResponseTimeOut (state, data) {
      state.updateStatusTimeOutResponse = data
    },
  },
  actions: {
    getListCredentials ({ commit }) {
      const endpoint = '/api/credentialsAll'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListCredentials', response.data.respuesta.Datos)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    async updateCredentials ({ commit }, data) {
      const endpoint = '/api/credentials'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data = { token_key: data.token_key, observation: data.observation, code_store: data.code_store, type_tef: data.type_tef, user: data.user, dataCredentials: data.dataCredentials }
      const response = await axios.create().put(url, data)
      commit(
        'setUpdateResponseCredentials',
        response.status >= 200 && response.status < 300
      )
      return response
    },
    async updateCredentialsTimeOut ({ commit }, data) {
      const endpoint = '/api/credentialsTimeout'

      data = {
        token_key: data.token_key,
        observation: data.observation,
        code_store: data.code_store,
        type_tef: data.type_tef,
        user: data.user,
        time_out_transaction: data.time_out_transaction,
        time_out_sequential: data.time_out_sequential
      }

      const url = environment.HIOPOSWEBSERVICES + endpoint

      try {
        const response = await axios
          .create()
          .put(url, data)

        commit(
          'setUpdateResponseTimeOut',
          response.statusText === 'OK'
        )

        return response
      } catch (error) {
        console.log(error.message)
        throw error
      }
    },
    async getListTerminales ({ commit }, data) {
      let params = `&client=${data.Client}`
      params += `&type_tef=${data.Tef}`

      const endpoint = '/api/credentialsClient?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      try {
        const response = await axios
          .create()
          .get(url)

        commit(
          'setListTerminales',
          response.data.respuesta.Datos
        )

        return response
      } catch (error) {
        console.log(error.message)
        throw error
      }
    },
    async getTerminals ({ commit }, IdCompania) {
      const endpoint = '/api/terminals'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      try {
        const response = await axios
          .create()
          .get(url, { params: { IdCompania } })

        commit('setListTerminals', response.data.respuesta.Datos)
        return response
      } catch (error) {
        console.log(error.message)
        throw error
      }
    },
    async createTerminal ({ commit }, data) {
      const endpoint = '/api/terminals'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      try {
        const response = await axios
          .create()
          .post(url, data)

        commit('setTerminalResponse', response.data.respuesta)
        return response
      } catch (error) {
        commit(
          'setTerminalResponse',
          error.response && error.response.data
            ? error.response.data.respuesta
            : null
        )
        throw error
      }
    },
    async getTerminalIntegrations ({ commit }, data) {
      const endpoint = '/api/terminals/integrations'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      try {
        const response = await axios
          .create()
          .get(url, { params: data })

        commit('setTerminalResponse', response.data.respuesta)
        return response
      } catch (error) {
        console.log(error.message)
        throw error
      }
    },
    async insertTerminalIntegrationsBulk ({ commit }, data) {
      const endpoint = '/api/terminals/integrations/bulk'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      try {
        const response = await axios
          .create()
          .post(url, data)

        commit('setTerminalResponse', response.data.respuesta)
        return response
      } catch (error) {
        commit(
          'setTerminalResponse',
          error.response && error.response.data
            ? error.response.data.respuesta
            : null
        )
        throw error
      }
    },
    insertCredentials ({ commit }, data) {
      const endpoint = '/api/credentials'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .post(url, data)
        .then(response => {
          if (response.data) {
              commit('setResponseCredentials', response.data.respuesta)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    setStatusResponse ({ commit }, data) {
      commit('setResponseCredentials', data)
    },
    setUpdateResponseCredentials ({ commit }, data) {
      commit('setUpdateResponseCredentials', data)
    },
	   setUpdateResponseTimeOut ({ commit }, data) {
      commit('setUpdateResponseTimeOut', data)
    },

  },
}
